/* eslint-disable react/button-has-type */
import React from 'react';
import classnames from 'classnames';
import useAnalytics from 'hooks/useAnalytics';

/**
 * @typedef {'agree' | 'disagree' | 'link' | 'block' | 'primary' | 'outline-primary' | 'secondary' | 'tertiary' | 'default' | 'gallery-media__delete'} ButtonTypes
 * @typedef {{
 *   analytics?: { category: string, action: string, label?: string, }
 *   buttonType?: ButtonTypes,
 * } & React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>} ButtonProps
 */
/** @type {React.FC<ButtonProps>} */
const Button = ({ children, buttonType = 'default', className, analytics, type = 'button', ...rest }) => {
  const { onClick } = useAnalytics();
  const classNames = classnames('btn', `btn--${buttonType}`, className);

  return (
    <button type={type} className={classNames} {...rest} onClick={onClick(analytics, rest.onClick)}>
      {children}
    </button>
  );
};
export default Button;
